<template>
  <div class="login--extra" />
</template>

<script>
const name = 'login-extra';
export default {
    name,
    componentName: name,

    data() {
        return {};
    },

    methods: {},
};
</script>


// WEBPACK FOOTER //
// login/Components/LoginExtra.vue